import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Header.css';

const Header = () => {
  const { t, i18n } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setMenuOpen(false);
  };

  const languages = [
    { code: 'en', name: 'English' },
    { code: 'he', name: 'עברית' },
    { code: 'ar', name: 'العربية' },
    { code: 'ru', name: 'Русский' },
  ];

  return (
    <header className="header" role="banner">
      <div className="container">
        <div className="header-content">
          <a href="/" className="logo" aria-label={`${t('appName')} - Home`}>
            <span className="logo-icon" aria-hidden="true"><img src="/images/logo.png" alt={t('appName')} /></span>
            <span className="logo-text"><span className="titleGlow">Glow</span><span className="titleApp">App</span></span>
          </a>
          
          <nav className={`nav ${menuOpen ? 'nav-open' : ''}`} role="navigation" aria-label="Main navigation">
            <a href="/#features" onClick={() => setMenuOpen(false)}>{t('features')}</a>
            <a href="/#benefits" onClick={() => setMenuOpen(false)}>{t('benefits')}</a>
            <a href="/#pricing" onClick={() => setMenuOpen(false)}>{t('pricing')}</a>
            <a href="/#faq" onClick={() => setMenuOpen(false)}>{t('faq')}</a>
            <a href="/#contact" onClick={() => setMenuOpen(false)}>{t('contact')}</a>
          </nav>

          <div className="header-actions">
            <div className="language-selector">
              <button 
                className="language-btn"
                onClick={() => setMenuOpen(!menuOpen)}
                aria-label="Select language"
              >
                {languages.find(l => l.code === i18n.language)?.name || 'EN'}
                <span className="dropdown-arrow">▼</span>
              </button>
              {menuOpen && (
                <div className="language-menu">
                  {languages.map((lang) => (
                    <button
                      key={lang.code}
                      className={`language-option ${i18n.language === lang.code ? 'active' : ''}`}
                      onClick={() => changeLanguage(lang.code)}
                    >
                      {lang.name}
                    </button>
                  ))}
                </div>
              )}
            </div>
            <a href="https://app.glowapp.me" target='_blank'className="btn btn-primary btn-start">
              {t('startNow')}
            </a>
          </div>

          <button 
            className="mobile-menu-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;